import React from 'react';
import UnSupportBrowser from 'components/UnSupportBrowser';

export default function BasicLayout(props) {
  const isIE =
    process.browser && window.navigator.userAgent.match(/(MSIE|Trident)/);

  if (isIE) return <UnSupportBrowser />;

  return (
    <div>
      {props.children}
      {/* language="CSS" */}
      <style jsx global>{`
        .ss-layout {
          display: flex;
          flex-direction: column;
        }

        .ss-wrapper {
          flex: 1 0 auto;
          position: relative;
          overflow-x: hidden;
          overflow-y: scroll;
        }

        .ss-center-wrapper {
          position: absolute;
          top: 50%;
          left: 0;
          right: 0;
          transform: translate(0, -50%);
        }

        .ss-container {
          position: relative;
          height: 100%;
          width: 100%;
          padding-top: 20px;
          padding-bottom: 20px;
        }
      `}</style>
    </div>
  );
}
